<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <!-- modal to view template start-->
        <b-modal id="bv-modal-example" hide-footer>
            <template #modal-title>
                Email Template 
            </template>
            <div class="d-block">
                <h3 v-html="formData.Salutation"></h3>
                <br>
                <p v-html="formData.TextBox1"></p>
                <hr />


                <ul class="poll text-left">
                    <li v-for="(landing, index) in landingPages" :key="index">
                        <a :href="links.headingLink" target="_blank"><span
                                style="font-weight:bold; text-decoration:underline" v-html="landing.Subject"></span>:</a>
                        <span v-html="landing.Salutation"></span>
                    </li>
                </ul>
                <hr />

                <p class="main-txt" v-html="formData.TextBox2"></p>
                <div v-show="pollShow">
                    <ul style="list-style-type:none" class="poll text-left new-poll">
                        <li :style="{ 'marginLeft': '45%' }" v-for="(item, index) in pollList" :key="index">
                            <a href="javascript:void(0)"><img
                                    src="https://dctrainings.com/gts/images/newsletter/ebullet.png" alt=""> </a><strong>{{
                                        item.Topic }}</strong>
                        </li>
                    </ul>
                </div>
                <div v-html="formData.TextBox3" />
            </div>
            <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close
                Me</b-button>
        </b-modal>
        <!-- modal to view template end-->
        <div class="row mt-5">
            <div class="col-md-12 d-flex align-items-stretch grid-margin">
                <div class="row flex-grow">

                    <div class="col-12 grid-margin">
                        <div class="card">
                            <div class="card-header">
                                <h4 class="card-title">Email Marketing Management</h4>
                            </div>
                            <div class="card-body">
                                <form action="" method="post" @submit.prevent="loadLandingPage">
                                    <div class="row">
                                        <div class="col-md-3 col-sm-6">
                                            <div role="group" class="form-group">
                                                <label for="ContentType" class="d-block">Content Type</label>
                                                <div>
                                                    <select class="custom-select" id="ContentType"
                                                        v-model="customFilters.ContentType" required name="ContentType">
                                                        <option value="Email">Email</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 col-sm-6">
                                            <div role="group" class="form-group">
                                                <label for="GroupID" class="d-block">Group</label>
                                                <div>
                                                    <select class="custom-select" @change="partShowfun" id="GroupID"
                                                        v-model="customFilters.GroupID" required name="GroupID">
                                                        <option value="">Select Group</option>
                                                        <option value="1">Group 1</option>
                                                        <option value="2">Group 2</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 col-sm-6">
                                            <div role="group" class="form-group">
                                                <label for="TopicID" class="d-block">Select Topic</label>
                                                <div>
                                                    <select class="custom-select" name="TopicID"
                                                        v-model="customFilters.TopicID" required id="TopicID">
                                                        <option value="">Select Topic</option>
                                                        <option v-for="(item, index) in topicOptions" :key="index"
                                                            :value="String(item.TopicID)">
                                                            {{ item.Topic }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-3 col-sm-6" v-show="partShow">
                                            <div role="group" class="form-group">
                                                <label for="PartID" class="d-block">Select Part</label>
                                                <div>
                                                    <select class="custom-select" name="PartID"
                                                        v-model="customFilters.PartID" id="PartID">
                                                        <option value="">Select an part</option>
                                                        <option v-for="item in 4" :key="item" :value="item">
                                                            part {{ item }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-sm-6">
                                            <b-button type="submit" variant="success" class="btn btn-success mt-4 btn-sm">
                                                <span>Content</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </form>
                                <br>
                                <form method="post" @submit.prevent="updateOrSaveLandingPage">
                                    <section class="blog-post" v-show='toggle'>
                                        <div>
                                            <div class="row">
                                                <div class="col-md-12 btn alert alert-danger"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'alert'">
                                                    <strong> Alert! Please set Scheduler for this Topic. </strong>
                                                </div>
                                                <div class="col-md-12 btn alert alert-danger"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'expire'">
                                                    <strong> This Scheduler Expired </strong>
                                                </div>

                                                <div class="col-md-12 btn alert alert-info"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'run'">
                                                    <strong>This Topic Scheduler will be run from {{ formData.StartDate }}
                                                        PDT to
                                                        {{ formData.StopDate }} </strong>
                                                </div>
                                                <div class="col-md-12 btn alert alert-warning"
                                                    style="text-align: left; padding: 15px; "
                                                    v-show="alertMessage == 'resume'">
                                                    <strong> This Topic Scheduler Stoped and it will be not run on untill
                                                        you resume. </strong>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 btn" style="padding: 20px;">
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 btn" style="padding: 20px;">
                                                </div>
                                                <div class="col-md-4 btn" style="padding: 20px;">
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <b-button variant="success"
                                                                @click="$bvModal.show('bv-modal-example'); viewTemplate();"
                                                                class="btn  btn-success">
                                                                <span>View Template</span>
                                                            </b-button>
                                                        </div>

                                                        <div class="col-md-6">
                                                            <b-button type="submit" variant="success"
                                                                class="btn  btn-success">
                                                                <span>Send Email</span>
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4 btn" style=" padding: 20px;">
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <section class="blog-post1" v-show='toggle'>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-form-group label="Subject" label-for="LastName">
                                                    <b-form-input type="text" id="subject" name="subject"
                                                        v-model="formData.Subject" aria-describedby="input-1-live-feedback">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12">
                                                <b-form-group label="Salutation" label-for="LastName">
                                                    <b-form-input type="text" id="salutation" name="salutation"
                                                        v-model="formData.Salutation"
                                                        aria-describedby="input-1-live-feedback">
                                                    </b-form-input>
                                                    <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                        field.
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <label class="control-label" for="message" style="margin-left:15px;">Description
                                                1 </label>
                                            <div class="col-md-12">
                                                <div id="Spotters">
                                                    <div id="app">
                                                        <ckeditor v-model="formData.TextBox1" :config="editorConfig"></ckeditor>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <h3>Landing pages</h3>
                                                    <ul class="poll text-left">
                                                        <li v-for="(landingPage, index) in landingPages" :key="index">
                                                            <a target="_blank"
                                                                :href="'https://dctrainings.com/LandingPage.cfm?pageid=' + landingPage.ContentID + '&title=' + landingPage.Subject"><strong>{{
                                                                    landingPage.Subject
                                                                }}:</strong></a>{{ landingPage.Salutation }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                        <div class="row">
                                            <label class="control-label" for="message" style="margin-left:15px;">Description
                                                2 </label>
                                            <div class="col-md-12">
                                                <div id="Spotters">
                                                    <div id="app">
                                                        <ckeditor v-model="formData.TextBox2" :config="editorConfig1"></ckeditor>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <br>
                                        <div class="row" v-show="pollShow">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <h3>Poll list</h3>
                                                    <ul style="list-style-type:none" class="poll text-left new-poll">

                                                        <li :style="{ 'marginLeft': '45%' }"
                                                            v-for="(item, index) in pollList" :key="index">
                                                            <a href="javascript:void(0)"><img
                                                                    src="https://dctrainings.com/gts/images/newsletter/ebullet.png"
                                                                    alt=""> </a><strong>{{ item.Topic }}</strong>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                        <br>
                                        <div class="row">
                                            <label class="control-label" for="message" style="margin-left:15px;">Description
                                                3 </label>
                                            <div class="col-md-12">
                                                <div id="Spotters">
                                                    <div id="app">
                                                        <ckeditor v-model="formData.TextBox3" :config="editorConfig2"  ></ckeditor>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <br>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <label for="checkbox">Set Scheduler ? </label>&nbsp;&nbsp;
                                                <input type="checkbox" id="checkbox" v-model="scheduler.addtimedate" />
                                            </div>
                                            <div class="col-md-3">
                                                <label for="checkbox">Days between sending </label>&nbsp;&nbsp;
                                                <input type="text" v-model="scheduler.DaysBtwnEM" name="DaysBtwnEM" />
                                            </div>
                                            <div class="col-md-3">
                                                <div>
                                                    <label for="SendTime">Send Time</label>&nbsp;&nbsp;
                                                    <!-- <input type="time" id="SendTime" @change="timepick"
                                                        v-model="formData.SendTime"> -->
                                                    <input type="time" id="SendTime" v-model="formData.SendTime">
                                                </div>
                                            </div>
                                            <div class="col-md-4 ">

                                                <div role="group" class="form-group">
                                                    <label for="Action">Action</label>
                                                    <select class="custom-select" name="Status"
                                                        v-model="formData.SchedulerStatus">
                                                        <option value="">Select Action</option>
                                                        <option value="resume">resume</option>
                                                        <option value="pause">pause</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <b-form-group id="ReferralDate" label="Start Date" label-for="ReferralDate">
                                                    <b-form-input id="ReferralDate" type="date"
                                                        v-model="formData.StartDate"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-4">
                                                <b-form-group id="ReferralDate" label="Stop Date" label-for="ReferralDate">
                                                    <b-form-input id="ReferralDate" type="date"
                                                        v-model="formData.StopDate"></b-form-input>
                                                </b-form-group>
                                            </div>

                                            <div class="col-md-4 mt-3">
                                                <b-button type="submit" variant="success"
                                                    class="btn float-right btn-success">
                                                    <span>Update</span>
                                                </b-button>
                                            </div>
                                        </div>
                                    </section>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>
<style>
#bv-modal-example .modal-dialog {
    max-width: 1001px;
}
</style>
<script>
import Vue from "vue";
import API from '@/api'
import CKEditor from 'ckeditor4-vue';

import moment from 'moment'

Vue.use(CKEditor);

export default {

    name: 'Users',
    data() {
        return {
            SendTimePicker: {
                SendTime: "10:00",
                UpdatedTime: ''
            },
            scheduler: {
                addtimedate: false,
                DaysBtwnEM: 0
            },
            customFilters: {
                ContentType: 'Email',
                TopicID: '',
                GroupID: '',
                PartID: '',
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            topicOptions: {},
            partShow: false,
            pollShow: false,
            formData: {
                id: "",
                Salutation: "",
                Subject: "",
                TextBox1: "",
                TextBox2: "",
                TextBox3: "",
                SendTime: "",
                StartDate: "",
                StopDate: ""
            },
            alertMessage: '',
            pollList: {},
            toggle: false,
            landingPages: {},
            links: {
                headingLink: ''
            }
        };
    },

    mounted() {
        this.getTopic();
    },
    methods: {
        getTopic() {
            API.getTopics(
                data => {
                    this.topicOptions = data.data
                }, err => { }
            )
        },
        viewTemplate() {
            this.links.headingLink = `https://dctrainings.com/LandingPage.cfm?pageid=${this.formData.id}&title=${this.formData.Subject}`;
        },

        loadLandingPage() {
            API.getEmailPageContent(this.customFilters, this.formShowData, this.errorCB)
            this.getScheduler();
            this.pollShow = (this.customFilters.GroupID == 1 ? true : false);
            if (this.customFilters.GroupID == 1) {
                this.pollListFun();
            }
            this.toggle = true;
        },
        formShowData(data) {
        if (data.data) {
            this.formData = {
            ...data.data,
            StartDate: moment(data.data.StartDate).format("yyyy-MM-DD"),
            StopDate: moment(data.data.StopDate).format("yyyy-MM-DD"),
            SendTime: moment.utc(data.data.SendTime, "HH:mm").format("HH:mm"),
            };
            this.getLandingpages();
            this.$showNotification({ message: "Data received successfully" }, "success");
        } else {
            console.error("Data is null or undefined");
        }
        },

        pollListFun() {
            API.getTopics(res => {
                this.pollList = res.data;
            }, this.errorCB);
        },
        partShowfun() {
            this.partShow = (this.customFilters.GroupID == 2 ? true : false);
        },
        updateOrSaveLandingPage() {
            this.formData.StartDate = moment(this.formData.StartDate).format("MM/DD/Y");
            this.formData.StopDate = moment(this.formData.StopDate).format("MM/DD/Y");
            this.formData.SendTime = moment.utc(this.formData.SendTime, "HH:mm").format("HH:mm A");
            let finalData = { ...this.formData, ...this.customFilters, ...this.scheduler };
            API.updateOrSaveLandingPage(finalData, this.addUpdateCB, this.errorCB);
            },
        addUpdateCB() {
            this.formData = {};
            this.toggle = false;
            this.$showNotification({ message: 'Data updated succesfully' }, "success")
        },
        alertMessageFun() {
            let SendTimeCheck = this.formData.SendTime;
            let StopDate = new Date(this.formData.StopDate + "T" + SendTimeCheck);
            let StartDate = new Date(this.formData.StartDate + "T" + SendTimeCheck);
            let NowDate = new Date();
            if (NowDate < StopDate && this.formData.SchedulerStatus == 'pause') {
                this.alertMessage = 'run';
            } else if (NowDate < StartDate && this.formData.SchedulerStatus == 'pause') {
                this.alertMessage = 'resume';
            } else if (this.formData.SchedulerStatus == '' || this.formData.SchedulerStatus == null) {
                this.alertMessage = 'alert';
            } else {
                this.alertMessage = 'expire';
            }
        },
        getLandingpages() {
            API.getLandingpagesDropdown(this.customFilters, this.LandingpagesCB, this.errorCB);
        },
        LandingpagesCB(response) {
            this.landingPages = response.data;
            this.alertMessageFun();
        },
        getScheduler() {
            API.getScheduler(this.schedulerCB, this.errorCB);
        },
        schedulerCB(res) {
            this.scheduler.DaysBtwnEM = res.data[0].DaysBtwnEM
        },
        errorCB(err) {
            this.$showNotification({ message: 'Failed system error' }, "error")
            console.log(err)
        },

    }, computed: {},
}
</script>

<style>
@media (max-width: 575px) {
    .btn-success.mt-4 {
        margin-top: 0 !important;
    }
}
</style>
